/**
 * Constants for the useFieldErrorHandler hook
 */

export const DEFAULT_ERROR_MESSAGE_SEPARATOR = ';';

export enum ERROR_TYPES {
    FORM_ERROR = 'FORM_ERROR',
    INPUT_ERROR = 'INPUT_ERROR',
    PROP_ERROR = 'PROP_ERROR',
}

export const DEFAULT_CONFIG = {
    autoSyncToForm: true,
    autoCleanup: true,
    updateDelay: 0,
} as const;

export const EMPTY_ERROR_STATE = {
    inputErrors: '',
    finalErrors: [] as string[],
    hasError: false,
} as const;
